import {
  UPDATE_START_ROUTE,
  UPDATE_END_ROUTE,
  CLEAR_ROUTE,
  CHANGE_ZOOM,
  CHANGE_CENTER,
  PREV_MAP,
  NEXT_MAP,
} from '../constants';

const powiatyInitialState = {
  startPoint: {
    x: null,
    y: null,
  },
  endPoint: {
    x: null,
    y: null,
  },
  hasBothPoints: false,
  zoomLevel: 13,
  bounds: null,
  prevMapHistory: [],
  nextMapHistory: [],
  currentCenter: [],
};

const setStartPoint = (state, action) => ({
  ...state,
  startPoint: {
    x: action.payload.x,
    y: action.payload.y,
  },
  hasBothPoints: state.endPoint ? true : false,
});
const setEndPoint = (state, action) => ({
  ...state,
  endPoint: {
    x: action.payload.x,
    y: action.payload.y,
  },
  hasBothPoints: state.startPoint ? true : false,
});
const clearRoute = (state) => ({
  ...state,
  startPoint: {
    x: null,
    y: null,
  },
  endPoint: {
    x: null,
    y: null,
  },
  hasBothPoints: false,
});
const changeZoom = (state, action) => ({
  ...state,
  zoomLevel: action.zoom,
  prevMapHistory: state.prevMapHistory[state.prevMapHistory.length - 1]['z'] !== action.zoom ?
    state.prevMapHistory.concat({
      'x': state.currentCenter[0], 'y': state.currentCenter[1], 'z': action.zoom
    }) :
    state.prevMapHistory
});
const changeCenter = (state, action) => ({
  ...state,
  currentCenter: action.currentCenter,
  prevMapHistory: state.prevMapHistory.length > 0 &&
  (state.prevMapHistory[state.prevMapHistory.length - 1]['y'] === action.currentCenter[1] ||
  state.prevMapHistory[state.prevMapHistory.length - 1]['x'] === action.currentCenter[0]) ?
    state.prevMapHistory.slice(0, -1).concat({
      'x': action.currentCenter[0], 'y': action.currentCenter[1], 'z': state.zoomLevel
    }) :
    state.prevMapHistory.concat({
      'x': action.currentCenter[0], 'y': action.currentCenter[1], 'z': state.zoomLevel
    })
});
const prevMap = state => ({
  ...state,
  currentCenter: state.prevMapHistory.length > 1 ?
    [
      state.prevMapHistory[state.prevMapHistory.length - 2]['x'],
      state.prevMapHistory[state.prevMapHistory.length - 2]['y']
    ]
    : [
      state.prevMapHistory[state.prevMapHistory.length - 1]['x'],
      state.prevMapHistory[state.prevMapHistory.length - 1]['y']
    ],
  zoomLevel: state.prevMapHistory && state.prevMapHistory.length > 1 ?
    state.prevMapHistory[state.prevMapHistory.length - 2]['z'] :
    state.prevMapHistory[state.prevMapHistory.length - 1]['z'],
  prevMapHistory: state.prevMapHistory.length > 1 ?
    state.prevMapHistory.slice(0, -1) :
    state.prevMapHistory,
  nextMapHistory: state.prevMapHistory.length > 1 ?
    state.nextMapHistory.concat({
    'x': state.prevMapHistory[state.prevMapHistory.length - 1]['x'],
    'y': state.prevMapHistory[state.prevMapHistory.length - 1]['y'],
    'z': state.prevMapHistory[state.prevMapHistory.length - 1]['z']
  }): state.nextMapHistory
});
const nextMap = state => ({
  ...state,
  zoomLevel: state.nextMapHistory[state.nextMapHistory.length - 1]['z'],
  currentCenter: [
      state.nextMapHistory[state.nextMapHistory.length - 1]['x'],
      state.nextMapHistory[state.nextMapHistory.length - 1]['y']
    ],
  nextMapHistory: state.nextMapHistory.length > 1 ?
    state.nextMapHistory.slice(0, -1) :
    state.nextMapHistory,
});

const nextMapAsFunction = state => {
  let newState = {
    ...state,
    currentCenter: state.nextMapHistory.length > 1 ?
      [
        state.nextMapHistory[state.nextMapHistory.length - 2],
        state.nextMapHistory[state.nextMapHistory.length - 1]
      ] :
      state.currentCenter,
    nextMapHistory:
    state.nextMapHistory.length > 2 ?
      state.nextMapHistory.slice(0, -2) :
      state.nextMapHistory
  };
  return newState;
};

export default function reducer(state = powiatyInitialState, action) {
  return ({
    [UPDATE_START_ROUTE]: setStartPoint,
    [UPDATE_END_ROUTE]: setEndPoint,
    [CLEAR_ROUTE]: clearRoute,
    [CHANGE_ZOOM]: changeZoom,
    [CHANGE_CENTER]: changeCenter,
    [PREV_MAP]: prevMap,
    [NEXT_MAP]: nextMap,
  }[action.type] || (s => s))(state, action);
}




// WEBPACK FOOTER //
// src/reducers/routing.js